import { render } from "./LOFooter.vue?vue&type=template&id=49231f8f&scoped=true"
import script from "./LOFooter.vue?vue&type=script&lang=js"
export * from "./LOFooter.vue?vue&type=script&lang=js"

import "./LOFooter.vue?vue&type=style&index=0&id=49231f8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49231f8f"]])

export default __exports__